<template>
<div>
    <div class="row">
        <div class="col">
            <h1 class="pb-6">{{paymentView ? 'Make a payment':'Invoice'}}</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-8 sau-set-bx">
            <transition mode="out-in" enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
                <div v-if="paymentView" key="paymentView" style="animation-duration: 0.5s">
                    <h3>Payment Methods</h3>
                    <p class="mb-1">We accept Credit Card payments secured by Stripe, PayPal, Direct Debit, and BPAY.</p>
                    <p>Please <a href="/support" target="_blank" title="Contact Us">contact us</a> if you need to pay by Purchase Order or Invoice.</p>
                    <sau-utility-payment-methods></sau-utility-payment-methods>
                </div>
                <div v-else key="invoiceView" style="animation-duration: 0.5s">
                    <sau-invoice></sau-invoice>
                </div>
            </transition>
        </div>
        <div class="col-lg-4">
            <sau-payment-aside></sau-payment-aside>
        </div>
    </div>
</div>
</template>

<script>
import sauPaymentAside from './_PaymentSummaryRHS';
import sauInvoice from './Invoice';
export default {
    props: ['paymentType', 'selectedInvoice'],
    components:{
		'sau-payment-aside': sauPaymentAside,
        'sau-invoice': sauInvoice
    },
    data(){
        return{
            show: true
        }
    },
    created() {
        this.$store.commit('setInvoice', this.selectedInvoice);

        this.vuexLoading().then(response => {
            if (this.userFeatures.hasOwnProperty('selectedPaymentMethod')) {
                this.$store.commit('paymentMethodSelected', this.userFeatures.selectedPaymentMethod);
            }
            this.getPaypalBAState().then(response => {
                this.$store.commit('paypalActiveBAOnFile', response.data.data.baState);
                this.$store.commit('paypalActiveBAEmail', response.data.data.baEmail);
                this.ready = true;
            });
        });

    },
    methods:{
        setPaymentView(view){
            this.$store.commit('setPaymentView', view);
        },
    }
}
</script>

<style>
.cf:after{
    content:"";
    display: table;
    clear: both;
    border: 1px solid green;
}
</style>
